import {
  between,
  requiredIf,
  or,
} from 'vuelidate/lib/validators';
import parametersFields
  from '@/domain/data/installation/engineering/isolationAging/parametersFields';

const fixedPeriod = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).fixedPeriod.required),
});
const initialDate = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).initialDate.required),
  isDateValid: parametersFields(parameters).initialDate.isDateValid,
  isMinDateValid: parametersFields(parameters).initialDate.isMinDateValid,
  isDateIntervalValid: parametersFields(parameters).initialDate.isDateIntervalValid,
});
const finalDate = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).finalDate.required),
  isDateValid: parametersFields(parameters).finalDate.isDateValid,
  isMinDateValid: parametersFields(parameters).finalDate.isMinDateValid,
  isDateIntervalValid: parametersFields(parameters).finalDate.isDateIntervalValid,
});
const initialTime = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).initialTime.required),
  isDateValid: parametersFields(parameters).initialTime.isDateValid,
  isDateIntervalValid: parametersFields(parameters).initialTime.isDateIntervalValid,
});
const finalTime = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).finalTime.required),
  isDateValid: parametersFields(parameters).finalTime.isDateValid,
  isDateIntervalValid: parametersFields(parameters).finalTime.isDateIntervalValid,
});
const days = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).days.required),
  between: between(
    parametersFields(parameters).days.minValue,
    parametersFields(parameters).days.maxValue,
  ),
});
const considerHumidity = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).considerHumidity.required),
});
const paperHumiditySource = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).paperHumiditySource.required),
});
const paperHumidity = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).paperHumidity.required),
  between: parametersFields(parameters).paperHumidity.required
    ? between(
      parametersFields(parameters).paperHumidity.minValue,
      parametersFields(parameters).paperHumidity.maxValue,
    )
    : or(requiredIf),
});
const referenceHumidity = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).referenceHumidity.required),
});
const referenceHumidityPercentage = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).referenceHumidityPercentage.required),
  between: parametersFields(parameters).referenceHumidityPercentage.required
    ? between(
      parametersFields(parameters).referenceHumidityPercentage.minValue,
      parametersFields(parameters).referenceHumidityPercentage.maxValue,
    )
    : or(requiredIf),
});
const humidityCurveMethod = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).humidityCurveMethod.required),
});
const oxygenOil = parameters => ({
  requiredIf: requiredIf(() => parametersFields(parameters).oxygenOil.required),
  between: parametersFields(parameters).oxygenOil.required
    ? between(
      parametersFields(parameters).oxygenOil.minValue,
      parametersFields(parameters).oxygenOil.maxValue,
    )
    : or(requiredIf),
});
const totalAssetLifeExpectancyInYears = parameters => ({
  requiredIf: requiredIf(() => (
    parametersFields(parameters).totalAssetLifeExpectancyInYears.required
  )),
  between: between(
    parametersFields(parameters).totalAssetLifeExpectancyInYears.minValue,
    parametersFields(parameters).totalAssetLifeExpectancyInYears.maxValue,
  ),
});

export default parameters => ({
  parameters: {
    fixedPeriod: fixedPeriod(parameters),
    initialDate: initialDate(parameters),
    finalDate: finalDate(parameters),
    initialTime: initialTime(parameters),
    finalTime: finalTime(parameters),
    days: days(parameters),
    considerHumidity: considerHumidity(parameters),
    paperHumiditySource: paperHumiditySource(parameters),
    paperHumidity: paperHumidity(parameters),
    referenceHumidity: referenceHumidity(parameters),
    referenceHumidityPercentage: referenceHumidityPercentage(parameters),
    humidityCurveMethod: humidityCurveMethod(parameters),
    oxygenOil: oxygenOil(parameters),
    totalAssetLifeExpectancyInYears: totalAssetLifeExpectancyInYears(parameters),
  },
});
